import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ExaminationDisplay } from '@modules/examination/models/examination-display';
import { UserNamePipe } from '@shared/pipes/user-name.pipe';
import { TuiHint } from '@taiga-ui/core';

@Component({
  selector: 'pxc-examination-info',
  imports: [TuiHint, CommonModule, TranslocoDirective, UserNamePipe],
  templateUrl: './examination-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationInfoComponent {
  @Input() readonly examination: ExaminationDisplay;
}
